<template>
    <div class="grid">
        <van-cell-group v-for="group in groupedData" :key="group[0].classify">
            <h2 v-if="grouping && group[0].classify.length>0">{{group[0].classify}}</h2>
            <template v-for="field in group">
                <van-field v-if="field.inputType === 0" :required="field.required" :label="field.fieldShowName"
                           :key="field.uuid + index" v-model="value[field.fieldName]" type="text"
                           @keyup="eval(field.onChange)"
                           placeholder="请填写" :readonly="field.readOnly"  :style="field.style"/>
                <van-field v-if="field.inputType === 1" :required="field.required" :label="field.fieldShowName"
                           :key="field.uuid + index" v-model="value[field.fieldName]" type="textarea" autosize
                           @keyup="eval(field.onChange)"
                           placeholder="请填写" :readonly="field.readOnly"  :style="field.style"/>
                <van-field v-if="field.inputType === 2" :required="field.required" :label="field.fieldShowName"
                           :key="field.uuid + index" v-model="value[field.fieldName]" type="number" @blur="transNumber"
                           placeholder="请填写" :readonly="field.readOnly"
                           @change="eval(field.onChange)" :style="field.style"/>
                <vant-field-date v-if="field.inputType === 4" v-model="value[field.fieldName]"
                                 :label="field.fieldShowName" :key="field.uuid + index" :required="field.required"
                                 :readonly="field.readOnly" :format="field.format"
                                 @change="eval(field.onChange)"  :cellStyle="field.style"/>
                <van-field-acb v-if="field.inputType === 6" v-model="value[field.fieldName]" :dict="field.dictionary"
                               :label="field.fieldShowName" :key="field.uuid + index" :required="field.required"
                               :filter="field.filter" :readonly="field.readOnly" :cellStyle="field.style"
                               :on-change="'let rowIndex = ' + index + ';' + field.onChange" :options="field.options">
                </van-field-acb>
                <van-field-acb v-if="field.inputType === 8" v-model="value[field.fieldName]" :dict="field.dictionary"
                               :label="field.fieldShowName" :key="field.uuid + index" :required="field.required"
                               :filter="field.filter" :readonly="field.readOnly" :multiple="true" :cellStyle="field.style"
                               :on-change="'let rowIndex = ' + index + ';' + field.onChange" :options="field.options"/>
                <van-field-attachment v-if="field.inputType === 9" v-model="value[field.fieldName]"
                               :label="field.fieldShowName" :key="field.uuid + index" :required="field.required"
                                :readonly="field.readOnly" :cellStyle="field.style"/>
            </template>
        </van-cell-group>
    </div>
</template>
<script>
    import {CellGroup, Field} from 'vant';
    import VantFieldDate from './VantFieldDate';
    import VanFieldAcb from './VanFieldAcb';
    import VanFieldAttachment from './VanFieldAttachment';

    const _ = require('lodash');

    export default {
        props: {
            value: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            descriptions: {
                type: Array,
                default: () => []
            },
            grouping: {
                type: Boolean,
                default: true
            },
            index: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
            }
        },
        components: {
            VantFieldDate,
            VanFieldAcb,
            VanFieldAttachment,
            [Field.name]: Field,
            [CellGroup.name]: CellGroup,
            [VantFieldDate.name]: VantFieldDate,
            [VanFieldAcb.name]: VanFieldAcb,
            [VanFieldAttachment.name]: VanFieldAttachment
        },
        methods: {
            transNumber(event) {
                let value = event.currentTarget.value;
                if (value.indexOf(".") > -1) {
                    value = (Math.floor(parseFloat(value) * 100)) / 100 + "";
                    event.currentTarget.value = value;
                }
            },
            eval(script) {	
                if (script) {
                    let rowIndex = this.index;
                    eval(script);
                }
            }
        },
        computed: {
            groupedData: function () {
                return _.groupBy(this.descriptions, item => item.classify);
            }
        },
        mounted() {}
    }
</script>
<style>
    h2 {
        margin: 0;
        font-weight: 400;
        font-size: 1rem;
        color: rgba(69, 90, 100, .6);
        padding: 1rem 1rem 0.4rem;
    }
	.grid>.van-cell-group>.van-cell>.van-cell__title{
		text-align: right;
		margin-right:1rem;
    }
    .grid>.van-cell-group>.van-cell--required::before {
        left: 107px;
        top: 13px;
    }
</style>